
export function isTrajectXUser(email: string): boolean {
	return email.endsWith("@trajectx.com");
}